import { createAction, props } from '@ngrx/store';
import { CustomerReportModel } from '@shared/data-access/models';


export const getDetail = createAction(
  '[PROJECT TRANSACTION] GET DETAIL',
  props<{item:CustomerReportModel}>()
);


